export const IDLE_MS = 60_000;
export const CHECKPOINT_MS = 15_000;
export const MAX_ACTIVE_MS = 86_400_000;
// Monotonic time only: changing the system clock cannot increase engagement.
export class EngagementClock {
  private activeMs = 0;
  private last: number;
  private lastActivity: number;
  private running = false;
  constructor(now: number) {
    this.last = now;
    this.lastActivity = now;
  }
  snapshot(now: number) {
    if (this.running)
      this.activeMs += Math.max(
        0,
        Math.min(now, this.lastActivity + IDLE_MS) - this.last,
      );
    this.last = now;
    this.activeMs = Math.min(MAX_ACTIVE_MS, this.activeMs);
    return Math.floor(this.activeMs);
  }
  setRunning(now: number, running: boolean) {
    this.snapshot(now);
    if (running && !this.running) this.lastActivity = now;
    this.running = running;
  }
  activity(now: number) {
    this.snapshot(now);
    this.lastActivity = now;
  }
}
